export const downloadFile = (url: string) => {
  let link = document.createElement("a");
  link.download = url;
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  link.remove();
};
